import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { getQueue, clearQueue, queueCount } from "../lib/offline";
import { toast } from "sonner";

const SyncContext = createContext(null);
export const useSync = () => useContext(SyncContext);

export function SyncProvider({ children }) {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);

  const refreshCount = useCallback(async () => {
    setPending(await queueCount());
  }, []);

  const flush = useCallback(async () => {
    if (!navigator.onLine) return;
    const q = await getQueue();
    if (q.length === 0) return;
    setSyncing(true);
    try {
      const invoices = q.filter((x) => x.type === "invoice").map((x) => x.payload);
      const covers = q.filter((x) => x.type === "cover").map((x) => x.payload);
      const orders = q.filter((x) => x.type === "order").map((x) => x.payload);
      const res = await api.post("/sync", { invoices, covers, orders });
      await clearQueue();
      await refreshCount();
      toast.success(`Sincronizzati ${q.length} elementi offline`);
      const sent = res.data?.applied?.orders_sent || 0;
      if (sent > 0) toast.success(`${sent} ordine${sent > 1 ? "i" : ""} inviato${sent > 1 ? "i" : ""} al fornitore`, { duration: 6000 });
      window.dispatchEvent(new Event("data-synced"));
    } catch (e) {
      // keep queue for retry
    } finally {
      setSyncing(false);
    }
  }, [refreshCount]);

  useEffect(() => {
    refreshCount();
    const goOnline = () => {
      setOnline(true);
      flush();
    };
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    const iv = setInterval(refreshCount, 4000);
    if (navigator.onLine) flush();
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      clearInterval(iv);
    };
  }, [flush, refreshCount]);

  return (
    <SyncContext.Provider value={{ online, pending, syncing, flush, refreshCount }}>
      {children}
    </SyncContext.Provider>
  );
}
